import React from 'react';
import { Card, CardHeader, Flex, Heading } from '@amzn/storm-ui';
import styled from 'styled-components';
import { ReportCostEstimation } from '@flexible-reports/pages/shared/report-cost-estimation/report-cost-estimation';
import { isCostEstimationLaunchEnabled } from '@flexible-reports/utils/app-utils';

const MainLayoutWrapper = styled(Flex)`
  width: 100%;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.large.default};
`;

const Container = styled(Flex)`
  flex: 1;
  min-width: 0;
`;

const EstimatedSizeCard = styled(Card)`
  flex: 0 0 20rem;
  position: sticky;
  top: ${({ theme }) => theme.spacing.xxxlarge.default};
  align-self: flex-start;
`;

interface ReportLayoutProps {
  children: React.ReactNode;
  estimatedSizeHeader: string;
  banners?: React.ReactNode;
  reportEstimatesData?: any;
  isLoading?: boolean;
  isError?: boolean;
  hasSelectedAccounts?: boolean;
  hasRequiredFields?: boolean;
  isOverThreshold?: boolean;
}

const LayoutContainer = styled(Flex)`
  width: 100%;
  max-width: 82.5rem;
  margin: 0 auto;
  gap: ${({ theme }) => theme.spacing.base.default};
`;

export const ReportLayout: React.FC<ReportLayoutProps> = ({
  children,
  estimatedSizeHeader,
  banners,
  reportEstimatesData,
  isLoading = false,
  isError = false,
  hasSelectedAccounts = false,
  hasRequiredFields = false,
  isOverThreshold = false
}) => {
  return (
    <LayoutContainer direction='column'>
      {banners}
      <MainLayoutWrapper>
        <Container direction='column' rowGap='base'>
          {children}
        </Container>
        {isCostEstimationLaunchEnabled() && (
          <EstimatedSizeCard>
            <CardHeader>
              <Heading renderAs='h4'>{estimatedSizeHeader}</Heading>
            </CardHeader>
            <ReportCostEstimation
              data={reportEstimatesData}
              isLoading={isLoading}
              isError={isError}
              hasSelectedAccounts={hasSelectedAccounts}
              hasRequiredFields={hasRequiredFields}
              isOverThreshold={isOverThreshold}
            />
          </EstimatedSizeCard>
        )}
      </MainLayoutWrapper>
    </LayoutContainer>
  );
};
